// Module
var code = "<div class=\"bouncing-tooltip-container\"> <div class=\"arrow {{$ctrl.position}}\"></div> <div class=\"content-container\"> <h1 class=\"bouncing-tooltip-title\">{{$ctrl.tooltipTitle}}</h1> <h2 class=\"bouncing-tooltip-message\">{{$ctrl.tooltipMessage}}</h2> <a class=\"action\" ng-click=\"$ctrl.onDismiss()\">GOT IT</a> </div> </div> ";
// Exports
module.exports = code;